// CONF
import { CreateConf } from './conf/Create.conf';
import { UpdateConf } from './conf/Update.conf';
import { ListConf } from './conf/List.conf';
import { FilterConf } from './conf/Filter.conf';
import { SearchConf } from './conf/Search.conf';
import { DetailConf } from './conf/Detail.conf';

// REDUX
import { reducer, actions, detailSelector, editSelector } from './slice';

// SELECTOR
import { tag, querySelector, listSelector } from './slice';

// SAGA
import { saga } from './saga';

// API
import { API } from './api';
import { ActionConf } from './conf/Action.conf';

export { reducer, saga, tag };

const logbook = {
  tag,
  query: {
    all: {
      selector: querySelector,
      action: actions.fetchAllAction,
      settings: API.logbooks,
      populate: '*',
    },
    detail: {
      action: actions.fetchDetailAction,
      settings: API.operation,
      populate: '*',
    },
    edit: {
      settings: API.update,
    },
    create: {
      settings: API.create,
    },
    delete: {
      settings: API.delete,
    },
    action: {
      settings: API.updateAllRows,
    },
  },
  search: {
    conf: SearchConf,
    actions: {
      search: actions.searchChange,
    },
  },
  filter: {
    conf: FilterConf,
    actions: {
      filter: actions.filterChange,
    },
  },
  list: {
    conf: ListConf,
    actions: {
      pagination: actions.paginationChange,
      sort: actions.sortChange,
      //ACTIONS FOR CHECKBOXS IN THE LIST
      selected: actions.selectedRowChange,
      selectedAll: actions.selectedAllChange,
      resetSelect: actions.resetSelectedAllChange,
    },
    selector: {
      data: listSelector,
    },
    add: {
      to: 'add',
    },
  },
  detail: {
    conf: DetailConf,
    selector: {
      data: detailSelector,
    },
    edit: {
      to: 'edit',
    },
  },
  edit: {
    conf: UpdateConf,
    selector: {
      data: editSelector,
    },
  },
  create: {
    conf: CreateConf,
  },
  remove: {
    selector: {
      data: detailSelector,
    },
    navigate: '/logbook',
  },
  action: {
    conf: ActionConf,
  },
};

export default logbook;
